import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { unseenReleases, markReleasesSeen, hasSeenAny } from "../lib/whatsNew";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export function ReleaseList({ releases }) {
  return releases.map((r) => (
    <div key={r.id} className="mb-4 last:mb-0" data-testid={`whats-new-release-${r.id}`}>
      <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-2">{r.title}</p>
      <ul className="space-y-2.5">
        {r.items.map((it) => <li key={it.h} className="text-sm"><b>{it.h}.</b> <span className="text-muted-foreground">{it.p}</span></li>)}
      </ul>
    </div>
  ));
}

// Popup on the first open after an update; brand-new households skip it
export default function WhatsNew() {
  const { state } = useStore();
  const [list, setList] = useState(null);
  useEffect(() => {
    if (!state.setupDone && !hasSeenAny()) return markReleasesSeen();
    const u = unseenReleases();
    if (u.length) setList(u);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!list) return null;
  const close = () => { markReleasesSeen(); setList(null); };
  return (
    <Dialog open onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto" data-testid="whats-new-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-primary" /> What's new</DialogTitle>
          <DialogDescription>Here's what changed since you last opened the app.</DialogDescription>
        </DialogHeader>
        <ReleaseList releases={list} />
        <Button className="w-full mt-2" onClick={close} data-testid="whats-new-close">Got it</Button>
      </DialogContent>
    </Dialog>
  );
}
